import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Small shared note rendered at the top of wizard steps that contain required
 * fields, e.g. "* Indicates a required field". Keeps the markup consistent
 * across steps and avoids duplication.
 */
const WizardRequiredNote = () => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
    <Box component="span" sx={{ color: 'error.main' }}>
      *
    </Box>{' '}
    Indicates a required field
  </Typography>
);

export default WizardRequiredNote;

